import { IDataModelTypeConfig } from 'frontend/dataModels/types/IDataModelTypeConfig'

import {
  COLUMNS_CONFIG,
  DEFAULT_COLUMNS,
  FIELDS,
  SUBSCRIPTIONS,
} from 'frontend/shuttle-transfers/shuttle-transfers-table-helpers'


export const ShuttleTransferDataModelTypeConfig: IDataModelTypeConfig = {
  fields: FIELDS,

  subscriptions: SUBSCRIPTIONS,
  defaultColumns: DEFAULT_COLUMNS,
  columnConfig: COLUMNS_CONFIG,
}
